import { useState } from "react"

import { useTheme } from "@mui/material/styles"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { DatePickerProps } from "@mui/x-date-pickers/DatePicker"

import { useDateLocale, useTranslation } from "@l2r-front/l2r-i18n"
import { CloseIcon, KeyboardArrowLeftIcon, KeyboardArrowRightIcon } from "@l2r-front/l2r-icons"

import { I18N_NAMESPACE } from "../../constants/i18n"

import * as Styled from "./L2RDatePicker.styled"

type L2RDatePickerProps = {
    disableOpenPicker?: boolean
    id?: string
} & DatePickerProps

export const L2RDatePicker = (props: L2RDatePickerProps) => {
    const {
        disableOpenPicker = false,
        ...otherProps
    } = props

    const locale = useDateLocale()

    const { t } = useTranslation(I18N_NAMESPACE)
    const theme = useTheme()
    const [open, setOpen] = useState(false)

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
            <Styled.DatePicker
                {...otherProps}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                slots={{
                    leftArrowIcon: KeyboardArrowLeftIcon,
                    rightArrowIcon: KeyboardArrowRightIcon,
                    clearIcon: CloseIcon,
                }}
                slotProps={{
                    ...otherProps.slotProps,
                    desktopPaper: {
                        ...otherProps.slotProps?.desktopPaper,
                        sx: {
                            boxShadow: theme.customShadow("LCS/Shadow-dropdown"),
                            borderRadius: theme.spacing(3),
                            marginTop: theme.spacing(1),
                        },
                    },
                    mobilePaper: {
                        ...otherProps.slotProps?.mobilePaper,
                        sx: {
                            boxShadow: theme.customShadow("LCS/Shadow-dropdown"),
                            borderRadius: theme.spacing(3),
                            marginTop: theme.spacing(1),
                        },
                    },
                    openPickerButton: {
                        ...otherProps.slotProps?.openPickerButton,
                        ...(disableOpenPicker && { sx: { display: "none" }, }),
                    },
                    textField: {
                        ...otherProps.slotProps?.textField,
                        ...(disableOpenPicker && { onClick: () => setOpen(!open), }),
                    },
                }}
                localeText={{
                    toolbarTitle: t(I18N_NAMESPACE, "datePicker.datePickerToolbarTitle"),
                    cancelButtonLabel: t(I18N_NAMESPACE, "datePicker.cancelButtonLabel"),
                    okButtonLabel: t(I18N_NAMESPACE, "datePicker.okButtonLabel"),
                }}
            />
        </LocalizationProvider>
    )
}
